import { render, staticRenderFns } from "./SimplePortfolio.vue?vue&type=template&id=67e4dbfe"
import script from "./SimplePortfolio.vue?vue&type=script&lang=js"
export * from "./SimplePortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports